<template>
    <div class="uk-child-width-1-2@s uk-child-width-1-3@l" uk-height-match target="> div > .uk-card" uk-grid>
        <div v-for="item in items" class="uk-card uk-card-small">
            <div class="uk-card-media-top" v-if="item.featured_media">
                <a :href="item.url" v-html="item.featured_media.data.thumbnail"></a>
            </div>
            <div class="uk-card-body">
                <h3 v-if="item.present"><a :href="item.url">{{item.present}}</a></h3>
                <p v-if="item.abstract">{{item.abstract}}</p>
            </div>
        </div>
    </div>
</template>
<script>
  import DataGridResults from 'js/theme-mixins/DataGridResults';

  export default {
    mixins: [DataGridResults],
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/assets/js/theme-components/grid/DataGridResults.vue